"use strict";

angular.module('app.models.deviceLogSettings', []).//
factory('__DeviceLogSettings', function (restmod, appConfig, __Datapoint,__DatapointValue,$filter) {
    'ngInject';
    
    return restmod.model('/Device').mix('BaseModel').mix({
        //$pk:'DeviceId',
        prepareLogSettings : function(){
            var r = this;
            if (r.LoggingLocalEnabled || r.LoggingServerEnabled || r.StatisticEnabled) {
                r.$UI.SomeLoggingEnabled = true;
            }else{
                r.$UI.SomeLoggingEnabled = false;
            }
        },
        // LogSettings : {hasOne : '__DeviceLogSetting'}
        $config: {name: 'ResponseData', plural: 'ResponseData'},
         $pk : 'DeviceId',
        $hooks: {
            'before-save': function (_req) {

                _req.url = appConfig().api_host + 'Device/AddOrUpdateLogSetting';
                
                _req.data.DatapointsToLog.forEach((datapoint) => {
                    if (
                        datapoint.DatapointValue.$type ===
                            "BMS.Shared.DatapointCore.DatapointValue`1[[System.Single, mscorlib]], BMS.Shared" &&
                        Number.isNaN(datapoint.DatapointValue.Value)
                    ) {
                        datapoint.DatapointValue.Value = "NaN";
                    }
                });
                
                _req.method = 'POST';
                var u = _req.data;
                _req.data = {'LogSetting': u};
            },
            'after-request':function(_req)
            {
                if(typeof _req.data == 'string'){
                    _req.data ={'DeviceId': _req.data};
                }
                if(_req.data == '0')
                {
                    _req.data ={'DeviceId': this.DeviceId};
                }
            },


            'after-feed': function(data){

                this.prepareLogSettings();

            },
            'update-logsettings': function(){
                this.prepareLogSettings();
            }

        },
        $extend: {
            Model: {

                $get: function (params) {
                    return this.$collection(params).$decorate(
                        {
                            'before-request': function (_req) {
                                _req.method = 'POST';
                                _req.params = null;
                                _req.data = params;
                                _req.url = appConfig().api_host + 'Device/GetLogSetting';
                            },
                            'after-request' :function(_req){
                                this.prepareLogSettings();
                                _req.data = [_req.data];
                            },
                        }, function () {

                            return this.$find();
                        });
                }
            },

            List: {
                 // If using restmod < 1.1.5 the use Collection instead.
                $orderBy: function(_what) {
                    var ordered = $filter('orderBy')(this, _what);
                    // reset the collection contents:
                    this.length = 0;
                    this.push.apply(this, ordered);
                    return this;
                }
            }
        }
    })


});


